import { render, staticRenderFns } from "./Investments.vue?vue&type=template&id=13d47fca&scoped=true"
import script from "./Investments.vue?vue&type=script&lang=js"
export * from "./Investments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d47fca",
  null
  
)

export default component.exports